import { datumIsoKort, datumIsoLang } from "@/i18n/datum";

/**
 * Dates arrive as `yyyy-MM-dd`. Re-exported from the shared formatters rather than spelled out
 * here: the month names were a Dutch array in this file, which is a translation hiding in a
 * helper - the sentence around a date would move to the catalog and the date itself would not.
 */

/** `3 november 2027` - the huisstijl's long form, for a heading. */
export const datumLang = datumIsoLang;

/** `03-11-2027` - for a table column, where the long form would not line up. */
export const datumKort = datumIsoKort;

/** Whether a wedstrijddag falls outside the seizoen it belongs to. Warns; never blocks. */
export function buitenSeizoen(datum: string, start: string, eind: string) {
  return datum < start || datum > eind;
}
